import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

// models
import { BarChartSettings } from '../../models/barChartSettings';
import { BAR_CHART_TEMPLATE_DATA } from '../../models/barChartTemplateData';
import { COLORS_PRESETS } from '../../models/colorPickerPresets';
import { IBarChartSettingsValue } from '../../models/barChartSettingsValue';
import { IBarChartParamValue } from '../../models/barChartParams';
import { IChartData } from '../../models/chartData';

type FormGroupType = {
	mainColor: FormControl<string>;
	secondaryColor: FormControl<string>;
	count: FormControl<number>;
	defaultMetric: FormControl<string>;
}

export interface IBarChartSettingsModalData {
	settings: BarChartSettings;
	chartName: string;
	metrics: Array<IBarChartParamValue>;
}

@Component({
    selector: 'app-bar-chart-settings-modal',
    templateUrl: './bar-chart-settings-modal.component.html',
    styleUrls: ['./bar-chart-settings-modal.component.scss'],
    standalone: false
})
export class BarChartSettingsModalComponent implements OnInit {

	chartData: IChartData = BAR_CHART_TEMPLATE_DATA;
	colorsPresets: Array<string> = COLORS_PRESETS;
	formGroup: FormGroup<FormGroupType>;
	settings: BarChartSettings;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: IBarChartSettingsModalData,
		private dialogRef: MatDialogRef<BarChartSettingsModalComponent>,
		private formBuilder: FormBuilder
	) {}

	ngOnInit(): void {
		this.settings = this.data.settings || new BarChartSettings();

		this.formGroup = this.formBuilder.group<FormGroupType>({
			mainColor: this.formBuilder.control<string>(this.settings.mainColor),
			secondaryColor: this.formBuilder.control<string>(this.settings.secondaryColor),
			count: this.formBuilder.control<number>(this.settings.count),
			defaultMetric: this.formBuilder.control<string>(this.settings.defaultMetric || this.data.metrics[0].key)
		});

		this.formGroup.valueChanges
			.pipe(debounceTime(1000))
			.subscribe((value: IBarChartSettingsValue) => {
				this.settings = new BarChartSettings(value);
			});
	}

	apply(): void {
		const value: IBarChartSettingsValue = this.formGroup.value;
		this.dialogRef.close(value);
	}

	close(): void {
		this.dialogRef.close();
	}
}
